import React, { useState, useContext } from "react";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { loginContext } from "../context/contexts";
import { postobj } from "../apicall/apicall";
import FormControl from "@mui/material/FormControl";
import { NotificationManager } from "react-notifications";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import { validated } from "../apicall/validateform";
import { dist_user } from "../apicall/constants";
import { validateField } from "../apicall/commonFunction";
import { form_add, buttonStyle } from "../style/style";

export default function AddUsers(props) {
  const { id } = useContext(loginContext);
  const [error, setError] = useState({});
  const [user, setuser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    role: "USER",
    id: id,
  });

  const handleChange = (e) => {
    const { value, name } = e.target;
    setuser({
      ...user,
      [name]: value,
    });
  };
  const validateForm = (data) => {
    let newErr = {};
    if (!data.first_name.trim()) {
      newErr.first_name = "First Name cannot be blank";
    }
    if (!data.last_name.trim()) {
      newErr.last_name = "Last Name cannot be blank";
    }
    if (!/^\d{1,10}$/.test(data.phone)) {
      newErr.phone = "Please enter a 10-digit phone number";
    }
    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(data.email)) {
      newErr.email = "Please enter a valid email address";
    }
    let val = validateField(data, dist_user);
    if (Object.keys(val).length > 0) {
      Object.keys(val).forEach((field) => {
        console.log(field);
        newErr[field] = val[field];
      });
    }

    if (Object.keys(newErr).length > 0) {
      setError(newErr);
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    const res = validateForm(user);
    if (
      validated(user) &&
      user["email"].includes("@") &&
      user["phone"].length <= 10 &&
      res
    ) {
      e.preventDefault();
      let url = process.env.REACT_APP_ZEWA_URL + "user/add/0/";
      const d = postobj(url, user);
      d.then((response) => {
        console.log(response.status);
        if (response.status === 200) {
          return response;
        }
        throw new Error(response);
      })
        .then((res) => {
          //console.log(res);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message);
          props.setadduser(false);
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Email already registered");
        });
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Please fill the form correctly");
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          id="outlined-multiline-flexible"
          label="Enter first name"
          helperText={error.first_name ? error.first_name : ""}
          error={error.first_name || false}
          name="first_name"
          sx={form_add}
          value={user.first_name}
          onChange={(e) => {
            handleChange(e);
          }}
        />

        <TextField
          id="outlined-multiline-flexible"
          label="Enter last name"
          name="last_name"
          helperText={error.last_name ? error.last_name : ""}
          error={error.last_name || false}
          sx={form_add}
          value={user.last_name}
          onChange={(e) => {
            handleChange(e);
          }}
        />

        <TextField
          id="outlined-multiline-flexible"
          label="Enter user email"
          name="email"
          helperText={error.email ? error.email : ""}
          error={error.email || false}
          sx={form_add}
          value={user.email}
          onChange={(e) => {
            handleChange(e);
          }}
        />
        <TextField
          id="outlined-multiline-flexible"
          label="Enter phone number"
          sx={form_add}
          value={user.phone}
          helperText={error.phone ? error.phone : ""}
          error={error.phone || false}
          name="phone"
          onChange={(e) => {
            handleChange(e);
          }}
        />

        <Box m={-1}>
          <Button
            variant="contained"
            color="primary"
            style={buttonStyle}
            onClick={(e) => {
              handleSubmit(e);
            }}
          >
            Add user
          </Button>
          <Button
            variant="contained"
            color="error"
            style={buttonStyle}
            onClick={(e) => {
              props.setadduser(false);
            }}
          >
            cancel
          </Button>
        </Box>
      </FormControl>
      <NotificationContainer />
    </Box>
  );
}
